import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import Display from "./components/Display";
import ConfigForm from "./components/ConfigForm";
import Sidebar from "./components/Sidebar";
import "./App.css";

function App() {
  const [blogs, setBlogs] = useState([]);
  const [configSubmitted, setConfigSubmitted] = useState(false);

  const handleNewBlog = (newBlog) => {
    setBlogs((prevBlogs) => [...prevBlogs, newBlog]);
  };

  const database = "ipo_info";

  return (
    <Router>
      <Routes>
        <Route path="/" element={<ConfigForm />} />
        <Route path="/" element={<Home />} />
        <Route path="/" element={<Sidebar database={database} />} />

        <Route path="/dashbord" element={<Display />} />
        <Route
          path="/dashbord/:blogId"
          element={<Home onNewBlog={handleNewBlog} />}
        />
        <Route
          path="/dashbord/addblog"
          element={<Home onNewBlog={handleNewBlog} />}
        />
      </Routes>
    </Router>
  );
}

export default App;
